"use strict"; // Copyright IBM Corp. 2015,2016. All Rights Reserved.
// Node module: strong-globalize
// This file is licensed under the Artistic License 2.0.
// License text available at https://opensource.org/licenses/Artistic-2.0
// tslint:disable:no-any

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var util = require("util");

function noop() {}

var StrongGlobalize =
/*#__PURE__*/
function () {
  function StrongGlobalize() {
    _classCallCheck(this, StrongGlobalize);

    this.setLanguage = noop;
    this.formatCurrency = this.c;

    this.d = function (value, options) {
      return value.toString();
    };

    this.formatDate = this.d;

    this.n = function (value, options) {
      return value.toString();
    };

    this.formatNumber = this.n;

    this.m = function (path, variables) {
      return util.format.apply(null, [path].concat(variables));
    };

    this.formatMessage = this.m;
    this.t = this.m;
    this.format = this.f;
    this.write = this.owrite;
  }

  _createClass(StrongGlobalize, [{
    key: "getLanguage",
    value: function getLanguage() {
      return 'en';
    }
  }, {
    key: "c",
    value: function c(value, currencySymbol, options) {
      return currencySymbol + ' ' + value.toString();
    }
  }, {
    key: "Error",
    value: function (_Error) {
      function Error() {
        return _Error.apply(this, arguments);
      }

      Error.toString = function () {
        return _Error.toString();
      };

      return Error;
    }(function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return Error.apply(null, args);
    })
  }, {
    key: "f",
    value: function f() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return util.format.apply(null, args);
    }
  }, {
    key: "ewrite",
    value: function ewrite() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return console.error(args);
    }
  }, {
    key: "owrite",
    value: function owrite() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return console.log(args);
    }
  }, {
    key: "rfc5424",
    value: function rfc5424(type, args, fn) {
      // Convert args from function args object to a regular array
      args = Array.prototype.slice.call(args);

      if (typeof args[0] === 'string') {
        // The first argument may contain formatting instructions like %s
        // which must be preserved.
        args[0] = type + ': ' + args[0];
      } else {
        args = [type, ': '].concat(args);
      }

      return fn.apply(console, args);
    } // RFC 5424 Syslog Message Severities

  }, {
    key: "emergency",
    value: function emergency() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return this.rfc5424('emergency', args, console.error);
    }
  }, {
    key: "alert",
    value: function alert() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return this.rfc5424('alert', args, console.error);
    }
  }, {
    key: "critical",
    value: function critical() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return this.rfc5424('critical', args, console.error);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      return this.rfc5424('error', args, console.error);
    }
  }, {
    key: "warning",
    value: function warning() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      return this.rfc5424('warning', args, console.warn);
    }
  }, {
    key: "notice",
    value: function notice() {
      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      return this.rfc5424('notice', args, console.log);
    }
  }, {
    key: "informational",
    value: function informational() {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }

      return this.rfc5424('informational', args, console.log);
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }

      return this.rfc5424('debug', args, console.log);
    } // Node.js console

  }, {
    key: "warn",
    value: function warn() {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }

      return this.rfc5424('warn', args, console.warn);
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        args[_key14] = arguments[_key14];
      }

      return this.rfc5424('info', args, console.log);
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        args[_key15] = arguments[_key15];
      }

      return this.rfc5424('log', args, console.log);
    } // Misc Logging Levels

  }, {
    key: "help",
    value: function help() {
      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        args[_key16] = arguments[_key16];
      }

      return this.rfc5424('help', args, console.log);
    }
  }, {
    key: "data",
    value: function data() {
      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        args[_key17] = arguments[_key17];
      }

      return this.rfc5424('data', args, console.log);
    }
  }, {
    key: "prompt",
    value: function prompt() {
      for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        args[_key18] = arguments[_key18];
      }

      return this.rfc5424('prompt', args, console.log);
    }
  }, {
    key: "verbose",
    value: function verbose() {
      for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
        args[_key19] = arguments[_key19];
      }

      return this.rfc5424('verbose', args, console.log);
    }
  }, {
    key: "input",
    value: function input() {
      for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
        args[_key20] = arguments[_key20];
      }

      return this.rfc5424('input', args, console.log);
    }
  }, {
    key: "silly",
    value: function silly() {
      for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
        args[_key21] = arguments[_key21];
      }

      return this.rfc5424('silly', args, console.log);
    }
  }]);

  return StrongGlobalize;
}();

StrongGlobalize.SetRootDir = noop;
StrongGlobalize.SetDefaultLanguage = noop;
StrongGlobalize.SetPersistentLogging = noop;
module.exports = StrongGlobalize;